import { getMethodWithToken } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const GET_FACE_BATCH_RESULT = 'GET_FACE_BATCH_RESULT';
export const GET_FACE_BATCH_RESULT_SUCCESS = 'GET_FACE_BATCH_RESULT_SUCCESS';
export const GET_FACE_BATCH_RESULT_FAILURE = 'GET_FACE_BATCH_RESULT_FAILURE';

// Action Creators
export const getFaceBatchResult = () => ({
  type: GET_FACE_BATCH_RESULT,
});

export const getFaceBatchResultSuccess = (users) => ({
  type: GET_FACE_BATCH_RESULT_SUCCESS,
  payload: users,
});

export const getFaceBatchResultFailure = (error) => ({
  type: GET_FACE_BATCH_RESULT_FAILURE,
  payload: error,
});

// Thunk Function
export const getFaceBatchResultCallAPI = (data, external) => {
  return async (dispatch) => {
    dispatch(getFaceBatchResult());
    try {
      const response = await getMethodWithToken(url.faceBatchResult + data);
      if (response?.status === 200 || response?.status === 201) {
        dispatch(getFaceBatchResultSuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
      }
    } catch (error) {
      dispatch(getFaceBatchResultFailure(error?.message));
    }
  };
};
